export default "/images/d728225936da8b33f3792783579b5fdd.avif";